import React,{useState,useEffect} from "react";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import "./About.css"
import Navigationbar from "../../components/header/Navigationbar";
import {Col, Container, Row} from "react-bootstrap"
import Carousel from "react-bootstrap/Carousel";
import Zoom from 'react-reveal/Zoom';
import WhatsAppCard from "../contact/WhatsAppCard";

const About=(props)=>{
  const [isScrollingUp, setIsScrollingUp] = useState(true);
  const [animationShown, setAnimationShown] = useState(false);

  const handleScroll = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  const handleTouchMove = (event) => {
    setIsScrollingUp(event.deltaY < 0);
  };
  useEffect(() => {
    if (isScrollingUp && !animationShown) {
      setAnimationShown(true);
    }

    window.addEventListener('wheel', handleScroll);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('wheel', handleScroll);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [isScrollingUp, animationShown]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return(
    <>
     <div className="educaton-main">
      <Navigationbar theme={props.theme}/>
      <div className="basic-education">
      <Container className="p-0 w-100" fluid  >
          <Col>
          <Carousel interval={2000} className="custom-carousel">
            <Carousel.Item>
              <img
                className="d-block w-100"
                src='/assets/images/about11.jpeg' 
                alt="First slide"
              />
              <Carousel.Caption >
                <h3 > ABOUT US</h3>
              </Carousel.Caption> 
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src='/assets/images/about17.jpg'
                alt="First slide"
              />
              <Carousel.Caption >
                <h3 > ABOUT US</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src='/assets/images/about14.jpeg'
                alt="First slide"
              />
              <Carousel.Caption >
                <h3 > ABOUT US</h3>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src='/assets/images/carousel_1.jpg'
                alt="First slide"
              />
              <Carousel.Caption >
                <h3 > ABOUT US</h3>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
          </Col>
       </Container>
        <div>
          <div className='about-weare'>
            <div className="about-weare-text">
              {isScrollingUp && animationShown ? (
                <>
                  <p className="about-weare-text-header">WHO WE ARE?</p>
                  <p className="about-weare-text-main">Welcome to Currency Growth Financial Services, where financial success meets personalized service. Established with a commitment to empower individuals and businesses, we are more than advisors; we are partners in your journey towards prosperity.</p>
                  <p className="about-weare-main">At Currency Growth Financial Services, we believe that financial success is a collaborative effort. We go beyond conventional financial services, fostering a relationship that extends beyond transactions. We take the time to understand your unique financial goals and aspirations, ensuring our strategies are tailored to your individual or business needs.</p>
                </>
              ) : (
                <Zoom>
                  <p className="about-weare-text-header">WHO WE ARE?</p>
                  <p className="about-weare-text-main">Welcome to Currency Growth Financial Services, where financial success meets personalized service. Established with a commitment to empower individuals and businesses, we are more than advisors; we are partners in your journey towards prosperity.</p>
                  <p className="about-weare-main">At Currency Growth Financial Services, we believe that financial success is a collaborative effort. We go beyond conventional financial services, fostering a relationship that extends beyond transactions. We take the time to understand your unique financial goals and aspirations, ensuring our strategies are tailored to your individual or business needs.</p>
                </Zoom>
              )}
            </div>
            {isScrollingUp && animationShown ? (
              <>
                <div className='about-weare-img'>
                  <img src='/assets/images/about3.jpg' className='about-weare-img-main' alt=""/>
                </div>
              </>
            ) : (
              <Zoom>
                <div className='about-weare-img'>
                  <img src='/assets/images/about3.jpg' className='about-weare-img-main' alt=""/>
                </div>
              </Zoom>
            )}
          </div>
          <div className='about-ourmission'>
            {isScrollingUp && animationShown ? (
              <>
                <div className='about-ourmission-img'>
                  <img src='/assets/images/about4.jpg' className='about-ourmission-img-main' alt=""/>
                </div>
              </>
            ) : (
              <Zoom>
                <div className='about-ourmission-img'>
                  <img src='/assets/images/about4.jpg' className='about-ourmission-img-main' alt=""/>
                </div>
              </Zoom>
            )}
            <div className='about-ourmission-text' id='missionText'>
              {isScrollingUp && animationShown ? (
                <>
                  <p className='about-ourmission-text-header'>Our Mission</p>
                  <p className='about-ourmission-text-main'>At Currency Growth Financial Services, our mission is deeply rooted in a commitment to empower individuals and businesses on their unique paths to financial success. We believe in going beyond the conventional roles of financial service providers; we are architects of dreams, enablers of growth, and partners in every financial journey.</p>
                  <p className='about-ourmission-text-main'>We are dedicated to understanding and championing your aspirations. Our mission is to empower you to dream big, providing the financial tools, strategies, and support needed to turn those dreams into tangible realities.</p>
                </>
              ) : (
                <Zoom>
                  <p className='about-ourmission-text-header'>Our Mission</p>
                  <p className='about-ourmission-text-main'>At Currency Growth Financial Services, our mission is deeply rooted in a commitment to empower individuals and businesses on their unique paths to financial success. We believe in going beyond the conventional roles of financial service providers; we are architects of dreams, enablers of growth, and partners in every financial journey.</p>
                  <p className='about-ourmission-text-main'>We are dedicated to understanding and championing your aspirations. Our mission is to empower you to dream big, providing the financial tools, strategies, and support needed to turn those dreams into tangible realities.</p>
                </Zoom>
              )}
            </div>
          </div> 
          <div className='about-ourvision'>
            <div className='about-ourvision-text'>
              {isScrollingUp && animationShown ? (
                <>
                  <p className='about-ourvision-text-header'>Our Vision</p>
                  <p className='about-ourvision-text-main'>At Currency Growth Financial Services, our vision extends far beyond the realms of traditional financial services. We are committed to catalyzing a future where every client not only reaches but surpasses their financial aspirations. We envision a landscape where financial growth is not just an outcome but a continuous journey, and we are your dedicated partners in navigating this path to prosperity.</p>
                  <p className='about-ourvision-main'>In our vision, success is not a one-size-fits-all concept. Whether you're an individual investor shaping your financial legacy or a business with grand expansion plans, we see a future where you not only achieve your goals but exceed them. Your success is not just a milestone for us; it is the heartbeat of our vision, driving every decision, strategy, and innovation.</p>
                </>
              ) : (
                <Zoom>
                  <p className='about-ourvision-text-header'>Our Vision</p>
                  <p className='about-ourvision-text-main'>At Currency Growth Financial Services, our vision extends far beyond the realms of traditional financial services. We are committed to catalyzing a future where every client not only reaches but surpasses their financial aspirations. We envision a landscape where financial growth is not just an outcome but a continuous journey, and we are your dedicated partners in navigating this path to prosperity.</p>
                  <p className='about-ourvision-main'>In our vision, success is not a one-size-fits-all concept. Whether you're an individual investor shaping your financial legacy or a business with grand expansion plans, we see a future where you not only achieve your goals but exceed them. Your success is not just a milestone for us; it is the heartbeat of our vision, driving every decision, strategy, and innovation.</p>
                </Zoom>
              )}
            </div>
            {isScrollingUp && animationShown ? (
              <>
                <div className='about-ourvision-img'>
                  <img src='/assets/images/about2.jpg' className='about-ourvision-img-main'/>
                </div>
              </>
            ) : (
              <Zoom>
                <div className='about-ourvision-img'>
                  <img src='/assets/images/about2.jpg' className='about-ourvision-img-main'/>
                </div>
              </Zoom>
            )}
          </div>
          </div>
        <div>
          {isScrollingUp && animationShown ? (
            <>
              <p className="about-ourteam-header" >OUR TEAMS</p>
              <p className="about-ourteam-main">At Currency Growth Financial Services, our teams are the backbone of our commitment to excellence and innovation. Comprising seasoned financial experts, technology enthusiasts, and client-centric professionals, our diverse teams collaborate seamlessly to provide you with cutting-edge financial solutions. From strategic planners to tech wizards, each team member is dedicated to ensuring your financial journey is marked by expertise, innovation, and unparalleled support. Together, we form a dynamic force that's not just focused on your present financial needs but is forward-thinking, shaping a future of financial success.</p>
            </>
          ) : (
            <>
              <Zoom bottom>
                <p className="about-ourteam-header" >OUR TEAMS</p>
                <p className="about-ourteam-main">At Currency Growth Financial Services, our teams are the backbone of our commitment to excellence and innovation. Comprising seasoned financial experts, technology enthusiasts, and client-centric professionals, our diverse teams collaborate seamlessly to provide you with cutting-edge financial solutions. From strategic planners to tech wizards, each team member is dedicated to ensuring your financial journey is marked by expertise, innovation, and unparalleled support. Together, we form a dynamic force that's not just focused on your present financial needs but is forward-thinking, shaping a future of financial success.</p>
              </Zoom>
            </>
          )}
        </div>
      </div>
      <Footer theme={props.theme} />
      <TopButton theme={props.theme} />
      <WhatsAppCard/>
    </div>
    </>
  )
}

export default About;
